"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _breakdancer = _interopRequireDefault(require("breakdancer"));
/**
 * Our breakpoint specifications. The key represents the name of the breakpoint
 * and the object specifies the specification in order to trigger the break
 * point. These breakpoints follow the design specification from our
 * invisionapp.
 *
 * Please note that the values in the breakdancer represent the minimum values
 * so need to + 1 the design specification in order to get an exact match.
 *
 * @type {Breakdancer}
 * @public
 */
const breakpoints = new _breakdancer.default([{
  name: 'mobile',
  width: 519 + 1
}, {
  name: 'phablet',
  width: 767 + 1
}, {
  name: 'tablet',
  width: 991 + 1
}, {
  name: 'desktop',
  width: 1199 + 1
}, {
  name: 'large',
  width: 1719 + 1
},
//
// Last capture all the things query.
//
{
  name: 'xlarge',
  width: Infinity
}]);
var _default = breakpoints;
exports.default = _default;